import React from 'react';
import './Badge.css';

/**
 * Baustein — Badge.
 * Kompakte Pill für Status-Indikator, Counts oder Tags.
 * Inline-Element, neutral was den Container betrifft.
 *
 * Props:
 *   tone     — 'default' | 'accent' | 'pending' | 'danger' (default 'default')
 *              default → graue Pill (Info / neutraler Count)
 *              accent  → akzent-gefüllt (positiver Status, z.B. „Freund")
 *              pending → gedämpft (wartender Status, z.B. „Angefragt", „Ausstehend")
 *              danger  → Fehler-Ton (endgültiger Status, z.B. „Ausgeschieden")
 *   size     — 'md' | 'lg' (default 'md')
 *              md → standard Größe
 *              lg → größere Pill (z.B. Deck-Typ im Editor-Kopf)
 *   struck   — durchgestrichen: der Inhalt gilt gerade nicht (z.B. ein stummgeschaltetes
 *              Thema). Die Pill bleibt sichtbar — sie ist weiterhin bedienbar.
 *   onClick  — macht die Pill zur Aktion: sie rendert dann als `<button>` mit Hover- und
 *              Fokus-Zustand statt als `<span>` (Themen-Chips, die man an- und abschaltet).
 *   button   — Pill als `<button>` ohne eigenen Klick-Handler; für Fälle, in denen eine
 *              fremde Fläche die Bedienung übernimmt (als `trigger` von `ui/ContextMenu`).
 *   pressed  — `aria-pressed` des Knopfes, für Chips mit zwei Zuständen.
 *   children — Label-Inhalt
 *
 * Weitere Props gehen ans Element durch, und die Komponente reicht ihre `ref` weiter —
 * eine klickbare Pill taugt damit als `trigger` von `ui/ContextMenu`.
 */
const Badge = React.forwardRef(function Badge(
  { tone = 'default', size = 'md', struck = false, onClick, button = false, pressed, children, ...rest },
  ref
) {
  const istKnopf = Boolean(onClick) || button;
  const classes = ['badge'];
  if (tone !== 'default') classes.push(`badge--${tone}`);
  if (size !== 'md') classes.push(`badge--${size}`);
  if (struck) classes.push('badge--struck');
  if (istKnopf) classes.push('badge--button');
  const className = classes.join(' ');

  if (!istKnopf) return <span ref={ref} {...rest} className={className}>{children}</span>;

  return (
    <button
      ref={ref}
      type="button"
      {...rest}
      className={className}
      aria-pressed={pressed}
      onClick={onClick}
    >
      {children}
    </button>
  );
});

export default Badge;
